<template lang="pug">
    .section
        .banner(:class="{ banner__fallback_container: no_image }")
            .banner__image(v-if="cover.default && cover.default.src").default
                img(v-bind="cover.default")
            .banner__image(v-if="cover.mobile && cover.mobile.src").mobile
                img(v-bind="cover.mobile")
            .container.banner__text(v-if="no_image")
                .row
                    .col-12(v-text="header")
        .container
            .row
                .col-12
                    .breadcrumb
                        .breadcrumb__item
                            router-link(to="/", :title="home_btn(locale)").breadcrumb__link
                                | {{home_btn(locale)}}
                        .breadcrumb__item(v-if="prefix && prefix_url")
                            router-link(:to="prefix_url", :title="prefix").breadcrumb__link
                                | {{ prefix }}
                        .breadcrumb__item(v-if="prefix_two && prefix_two_url")
                            router-link(:to="prefix_two_url", :title="prefix_two").breadcrumb__link
                                | {{ prefix_two }}
                        .breadcrumb__item(v-text="name")
</template>

<script>
    export default {
        name: "LayoutBannerBreadCrumb",
        props: {
            cover: Object,
            name: String,
            locale: String,
            breadcrumb: Array,
            title: String,
            prefix: String,
            prefix_url: String,
            prefix_two: String,
            prefix_two_url: String
        },
        computed: {
            header() {
                return this.title || this.name;
            },
            no_image() {
                return !(this.cover.default.src && this.cover.mobile.src);
            }
        },
        methods: {
            home_btn(locale) {
                return locale === 'en' ? 'Home' : '主頁';
            }
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    .banner
        &__image
            img
                width: 100%
            &.mobile
                display: none
            @include media-breakpoint-down(md)
                &.default
                    display: none
                &.mobile
                    // margin-top: 5.2rem
                    display: block

        &__fallback_container
            height: 450px
            @include media-breakpoint-down(md)
                height: 150px
            .banner__text
                position: relative
                top: 50%
                font-weight: bold
                font-size: 4.875rem
                color: #76cce1
                transform: translateY(-50%)
                font-variant: small-caps

                @include media-breakpoint-down(md)
                    font-size: 1.56rem
                    padding-left: 15px
                    padding-right: 15px


    .breadcrumb
        margin: 2rem auto
        font-size: 1.25rem
        @include media-breakpoint-down(md)
            padding-left: 0
            padding-right: 0
            margin: 1rem auto
            font-size: .875rem

        &__item
            display: inline-block
            color: #76cce1

            &:not(:last-child):after
                content: '>'
                display: inline-block
                margin: 0 1rem
                color: #454545

            a, a:visited
                color: #454545
</style>
